import { gql } from '@apollo/client';
const REMOVE_TENANT_ELEMENT = gql `
  mutation RemoveTenantTemplateElement($elementId: ID!) {
    removeModelSpecificationTemplateElement(elementId: $elementId) {
      removed
    }
  }
`;
export default REMOVE_TENANT_ELEMENT;
